var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAppDispatch } from "@application/store/useStore";
import { forceDisconnectNode, deleteNode, } from "@reducers/nodes/thunk/nodes-thunk";
export const useNodesActions = () => {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const { t } = useTranslation(["form", "validation", "common"]);
    // Navigation actions
    const handleAddNode = () => {
        navigate("/nodes/new");
    };
    const handleEditNode = (nodeId) => {
        navigate(`/nodes/${nodeId}/edit`);
    };
    const handleViewNode = (nodeId) => {
        // If you had a view page, this would navigate there
    };
    /**
     * Disconnect a node from its associated Access Point.
     * This uses the same logic as AP Profile disconnect - it sets
     * Clears simulated connection (disconnect) instead of deleting the node.
     * @param nodeId - The node's database ID
     * @returns Promise that resolves when disconnect is complete
     */
    const handleDisconnectNode = (nodeId) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            yield dispatch(forceDisconnectNode({ nodeId })).unwrap();
            return true;
        }
        catch (error) {
            console.error("Failed to disconnect node:", error);
            throw error;
        }
    });
    const handleConfigureAPDevice = (accessPointUid) => {
        navigate(`/dashboard/${accessPointUid}`);
    };
    const handleDeleteNode = (nodeId) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            yield dispatch(deleteNode(nodeId)).unwrap();
            return true;
        }
        catch (error) {
            console.error("Failed to delete node:", error);
            throw error;
        }
    });
    // Node management actions
    const handleBulkDisconnect = (nodeIds) => __awaiter(void 0, void 0, void 0, function* () {
        // TODO: Implement bulk disconnect if needed
    });
    const handleExportNodes = () => { };
    const handleImportNodes = () => { };
    // Individual node action handlers
    const getNodeActions = (node) => ({
        edit: () => handleEditNode(node.id),
        view: () => handleViewNode(node.id),
        disconnect: () => handleDisconnectNode(node.id),
        configureAPDevice: () => handleConfigureAPDevice(node.id),
        delete: () => handleDeleteNode(node.id),
    });
    return {
        // Navigation actions
        handleAddNode,
        handleEditNode,
        handleViewNode,
        handleDisconnectNode,
        handleDeleteNode,
        handleConfigureAPDevice,
        // Bulk actions
        handleBulkDisconnect,
        handleExportNodes,
        handleImportNodes,
        // Action configurations
        getNodeActions,
    };
};
